import { useMemo } from 'react';

import { toDate } from '../../utils/datetime';

const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

export interface Props {
  date: Date | UnixTime;
}

const useDateWidgetVM = ({ date }: Props) => {
  const { dateNum, dayName, monthName } = useMemo(() => {
    const d = toDate(date);

    return {
      dayName: dayNames[d.getDay()],
      dateNum: d.getDate().toString().padStart(2, '0'),
      monthName: monthNames[d.getMonth()],
    };
  }, [date]);

  return { dateNum, dayName, monthName };
};

export default useDateWidgetVM;
